var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39154 15.6085H2.41201L12.6862 5.33424L11.6658 4.31378L1.39154 14.588V15.6085ZM15.6316 4.33697L12.663 1.36835L13.6371 0.39427C13.9 0.131423 14.2246 0 14.6112 0C14.9977 0 15.3224 0.131423 15.5853 0.39427L16.6057 1.41473C16.8686 1.67758 17 2.00227 17 2.38881C17 2.77535 16.8686 3.10005 16.6057 3.36289L15.6316 4.33697ZM14.6576 5.31105L2.96862 17H0V14.0314L11.6889 2.34243L14.6576 5.31105ZM12.176 4.82401L11.6658 4.31378L12.6862 5.33424L12.176 4.82401Z",
    fill: "#002868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencle);
export default __webpack_public_path__ + "static/media/pencle.afca7d6dab7b39002e863bf6c154cdc5.svg";
export { ForwardRef as ReactComponent };